module.exports = __webpack_public_path__ + "assets/img/tx102n_3.64235e6b.jpg";